/**
 * Created by lihaohua on 2019/1/15 10:16
 */

import Bridge from '../bridge'

const Reg_Common_Base_sendOpenToken = (callback) => {
  Bridge.WebViewJavascriptBridge.setup((JSBridge) => {
    JSBridge.registerHandler('GTBridge_Common_Base_sendOpenToken', callback)
  })
}

export default {Reg_Common_Base_sendOpenToken}
